
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import { MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes"
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';
import MainCatalogList from './MainCatalogList';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';



/**
 * Home-Navigation für Orchesterdienste-Bereich
 */


enum NavigationGroups{
    VAM = "MainCatalogsEditor_MainTitle_VAM",
    OM = "MainCatalogsEditor_MainTitle_OM",
    Process = "MainCatalogsEditor_MainTitle_Process",
    Address = "MainCatalogsEditor_MainTitle_Address",
    Employment = "MainCatalogsEditor_MainTitle_Employment",
    Todo = "MainCatalogsEditor_MainTitle_Todo",
    File = "MainCatalogsEditor_MainTitle_File",
    Settings = "MainCatalogsEditor_MainTitle_Settings"
}

enum FeaturePaths {
    OM = "MainCatalog/OM",
    VAM = "MainCatalog/VAM",
    Address = "MainCatalog/Address",
    Process = "MainCatalog/Process",
    Employment = "MainCatalog/Employment",
    Todo = "MainCatalog/Todo",
    File = "MainCatalog/File",
    Settings = "MainCatalog/Settings",
    Composers = "MainCatalog/Composers",
    Performers = "MainCatalog/Performers",
    PhysicalResources = "MainCatalog/PhysicalResources",
    ResourceMainGroup = "MainCatalog/ResourceMainGroup",
    RelationTypes = "MainCatalog/RelationTypes",
    RelationGroups = "MainCatalog/RelationGroups",
    SellingStatus = "MainCatalog/SellingStatus",
}

interface recordWithClassname {
    classname: MainCatalogs_Classes
}
class MainCatalogsNavigation extends compose(WidgetNavigationMap<recordWithClassname>) {

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.layoutConfig["tiles"].tileWidth = "25ch";
        //this.layoutConfig["rows"].navigationAreaWidthBaseValue = "50%";
        //this.layoutConfig["rows"].navigationAreaLayout = "tiles";


    }


    private _onSelect_Navigation(mapEntry: WidgetNavigation.mappingConfig & recordWithClassname) {
        let mcList;

        if (this.isEmbeddedInTab) {

            let existingTab = this.getExistingTab("list-" + mapEntry.classname);
            if (existingTab) {
                mcList = existingTab.widget;
            } else {
                mcList = new MainCatalogList();
            }
        } else {

            mcList = new MainCatalogList();
        }

        let heading = mapEntry.label;

        // Stammdaten haben eigenes Navigation-Callback, weil der Klassenname an die Basiswidgets darunter weitergegeben werden muss

        if (this.isEmbeddedInTab) {
            this.requestNewTabbedContent({
                enableClosing: true,
                label: heading,
                iconclass: mapEntry.icon,
                name: "list-" + mapEntry.classname,
                widget: mcList,
                coloration: mapEntry.colorClass,
                groupLabel: heading,
                sidebarEntryName: "list-" + mapEntry.classname
                //iconclass:
            }, true);
        } else {
            // in Popup maybe
            //alert("todo: anzeige wenn nicht in Tab eingebettet noch offen!")
            let dlg = new GenericDialog();
            dlg.setup({
                content: mcList,
                header: heading,
                frameColor: mapEntry.colorClass,
                size: "larger"
            });
        }

        mcList.setCatalog(mapEntry.classname, heading);
    }


    startup(): void {
        super.startup.apply(this, arguments as any);

        let navigationAreasettings: WidgetNavigation.navigationAreaSettings = {

        };
        navigationAreasettings[NavigationGroups.VAM] = {

        }

        this.setup(
            {

                /**
                 *
                 * VAM
                 *
                 *
                 */

                "EvActivityStatus": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-theater-masks",
                    label: "General_Label_EvActivityStatus",
                    colorClass: "w3-green",
                    roles: ["MainCatalogsEditor_EvActivityStatus"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvActivityStatus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvBookingStatus": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-traffic-light",
                    label: "General_Label_EvBookingStatus",
                    colorClass: "w3-light-green",
                    roles: ["MainCatalogsEditor_EvBookingStatus"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvBookingStatus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "Venues": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-home",
                    label: "General_Label_Venue",
                    colorClass: "w3-blue-gray",
                    roles: ["MainCatalogsEditor_Venues"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.Venues,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvRooms": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-map-marker-alt",
                    label: "General_Label_EvRoom",
                    colorClass: "w3-blue",
                    roles: ["MainCatalogsEditor_EvRooms"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvRoom,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "ServiceCategories": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-list-alt",
                    label: "General_Label_ServiceCategory",
                    colorClass: "w3-red",
                    roles: ["MainCatalogsEditor_ServiceCategories"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.ServiceCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvServices": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-list-ul",
                    label: "General_Label_EvService",
                    colorClass: "w3-amber",
                    roles: ["MainCatalogsEditor_EvServices"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvServices,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "ServicePackages": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-cube",
                    label: "General_Label_ServicePackage",
                    colorClass: "w3-orange",
                    roles: ["MainCatalogsEditor_ServicePackages"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.ServicePackage,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "ServiceChecklist": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-list-ul",
                    label: "General_Label_ServiceChecklist",
                    colorClass: "w3-red",
                    roles: ["MainCatalogsEditor_ServiceChecklist"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.ServiceChecklist,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "ServiceChecklistCategories": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-list-alt",
                    label: "General_Label_ServiceChecklistCategory",
                    colorClass: "w3-red",
                    roles: ["MainCatalogsEditor_ServiceChecklistCategories"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.ServiceChecklistCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "ServicePackChecklist": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-cube",
                    label: "General_Label_ServicePackChecklist",
                    colorClass: "w3-red",
                    roles: ["MainCatalogsEditor_ServicePackChecklist"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.ServicePackChecklist,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvCategories_1": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-palette",
                    label: "General_Label_EvCategory1",
                    colorClass: "w3-yellow",
                    roles: ["MainCatalogsEditor_EvCategories_1"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvCategory_1,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvCategories_2": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-palette",
                    label: "General_Label_EvCategory2",
                    colorClass: "w3-pale-yellow",
                    roles: ["MainCatalogsEditor_EvCategories_2"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvCategory_2,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "EvProjectType2": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-cubes",
                    label: "General_Label_EvProjectType2",
                    colorClass: "w3-yellow",
                    roles: ["MainCatalogsEditor_EvProjectType2"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvProjectType2,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "Professions": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-guitar",
                    label: "General_Label_Professions",
                    colorClass: "w3-amber",
                    roles: ["MainCatalogsEditor_Professions"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.Professions,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "Opus": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-compact-disc",
                    label: "General_Label_Opus",
                    colorClass: "w3-red",
                    roles: ["MainCatalogsEditor_Opus"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.Opus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "ResourceMainGroup": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-object-group",
                    label: "General_Label_ResourceMainGroup",
                    colorClass: "w3-pink",
                    roles: ["MainCatalogsEditor_ResourceMainGroup"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.ResourceMainGroup,
                    classname: MainCatalogs_Classes.ResourceMainGroup,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "PhysicalResources": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-chair",
                    label: "General_Label_PhysicalResources",
                    colorClass: "w3-purple",
                    roles: ["MainCatalogsEditor_PhysicalResources"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.PhysicalResources,
                    classname: MainCatalogs_Classes.PhysicalResources,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "SellingStatus": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-receipt",
                    label: "General_Label_SellingStatus",
                    colorClass: "w3-teal",
                    roles: ["MainCatalogsEditor_SellingStatus"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.SellingStatus,
                    classname: MainCatalogs_Classes.SellingStatus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "DistributionChannel": {
                    navigationAreaName: NavigationGroups.VAM,
                    icon: "fas fa-share-alt-square",
                    label: "General_Label_DistributionChannel",
                    colorClass: "w3-light-blue",
                    roles: ["MainCatalogsEditor_DistributionChannel"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.DistributionChannel,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                /**
                  *
                  *
                  * ADRESSEN
                  *
                  */
                "AddressCategory": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-address-book",
                    label: "General_Label_AddressCategory",
                    colorClass: "w3-purple",
                    roles: ["MainCatalogsEditor_AddressCategory"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.AddressCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "AddressMainCategory": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-address-book",
                    label: "General_Label_AddressMainCategory",
                    colorClass: "w3-deep-purple",
                    roles: ["MainCatalogsEditor_AddressCategory"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.AddressMainCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },

                "PostalCodes": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-map-pin",
                    label: "General_Label_PostalCodes",
                    colorClass: "w3-light-blue",
                    roles: ["MainCatalogsEditor_PostalCodes"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.PostalCodes,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "JobTitle": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-hard-hat",
                    label: "General_Label_JobTitleTile",
                    colorClass: "w3-yellow",
                    roles: ["MainCatalogsEditor_JobTitle"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.JobTitle,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "ProfessionalTitles": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-hard-hat",
                    label: "General_Label_ProfessionalTitlesTile",
                    colorClass: "w3-amber",
                    roles: ["MainCatalogsEditor_ProfessionalTitles"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.ProfessionalTitles,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "AcademicTitlesPrefix": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-graduation-cap",
                    label: "General_Label_AcademicTitlesPrefix",
                    colorClass: "w3-cyan",
                    roles: ["MainCatalogsEditor_AcademicTitlesPrefix"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.AcademicTitlesPrefix,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "AcademicTitlesSuffix": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-graduation-cap",
                    label: "General_Label_AcademicTitlesSuffix",
                    colorClass: "w3-teal",
                    roles: ["MainCatalogsEditor_AcademicTitlesSuffix"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Address,
                    classname: MainCatalogs_Classes.AcademicTitlesSuffix,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "Performers": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-user-tag",
                    label: "General_Label_Performers",
                    colorClass: "w3-purple",
                    roles: ["MainCatalogsEditor_Performers"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Performers,
                    classname: MainCatalogs_Classes.Performers,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "Composers": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-music",
                    label: "General_Label_Composers",
                    colorClass: "w3-orange",
                    roles: ["MainCatalogsEditor_Composers"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Composers,
                    classname: MainCatalogs_Classes.Composers,
                    callback: lang.hitch(this, this._onSelect_Navigation)
                },
                "RelationTypes": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-network-wired",
                    label: "General_Label_RelationTypes",
                    colorClass: "w3-lime",
                    roles: ["MainCatalogsEditor_RelationTypes"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.RelationTypes,
                    classname: MainCatalogs_Classes.RelationTypes,
                    callback: lang.hitch(this, this._onSelect_Navigation)
                },
                "RelationGroups": {
                    navigationAreaName: NavigationGroups.Address,
                    icon: "fas fa-object-ungroup",
                    label: "General_Label_RelationGroups",
                    colorClass: "w3-light-green",
                    roles: ["MainCatalogsEditor_RelationGroups"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.RelationGroups,
                    classname: MainCatalogs_Classes.RelationGroups,
                    callback: lang.hitch(this, this._onSelect_Navigation)
                },
                /**
                *
                * OM
                *
                *
                */

                "DutyTypes": {
                    navigationAreaName: NavigationGroups.OM,
                    icon: "fas fa-cubes",
                    label: "General_Label_DutyType",
                    colorClass: "w3-light-blue",
                    roles: ["MainCatalogsEditor_DutyTypes"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.OM,
                    classname: MainCatalogs_Classes.OMDutyType,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "FunctionalGroups": {
                    navigationAreaName: NavigationGroups.OM,
                    icon: "fas fa-drum",
                    label: "General_Label_FunctionalGroup",
                    colorClass: "w3-deep-orange",
                    roles: ["MainCatalogsEditor_FunctionalGroups"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.OM,
                    classname: MainCatalogs_Classes.FunctionalGroup,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "InternalInstruments": {
                    navigationAreaName: NavigationGroups.OM,
                    icon: "fas fa-guitar",
                    label: "General_Label_InternalInstruments",
                    colorClass: "w3-light-green",
                    roles: ["MainCatalogsEditor_InternalInstruments"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.OM,
                    classname: MainCatalogs_Classes.InternalInstrument,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "ExternalInstruments": {
                    navigationAreaName: NavigationGroups.OM,
                    icon: "fas fa-guitar",
                    label: "General_Label_ExternalInstruments",
                    colorClass: "w3-purple",
                    roles: ["MainCatalogsEditor_ExternalInstruments"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.OM,
                    classname: MainCatalogs_Classes.ExternalInstrument,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                /**
               *
               *
               * DIENSTE
               *
               */


                "EvTaskDescriptGroup": {
                    navigationAreaName: NavigationGroups.Employment,
                    icon: "fas fa-cube",
                    label: "General_Label_EvTaskDescriptGroup",
                    colorClass: "w3-cyan",
                    roles: ["MainCatalogsEditor_EvTaskDescript"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvTaskDescriptGroup,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvTaskDescript": {
                    navigationAreaName: NavigationGroups.Employment,
                    icon: "fas fa-cubes",
                    label: "General_Label_EvTaskDescript",
                    colorClass: "w3-teal",
                    roles: ["MainCatalogsEditor_EvTaskDescript"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.VAM,
                    classname: MainCatalogs_Classes.EvTaskDescript,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },


                /**
               *
               *
               * TODO
               *
               */

                "TodoPackages": {
                    navigationAreaName: NavigationGroups.Todo,
                    icon: "fas fa-cube",
                    label: "General_Label_TodoPackages",
                    colorClass: "w3-light-blue",
                    roles: ["MainCatalogsEditor_Todos"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Todo,
                    classname: MainCatalogs_Classes.TodoPackage,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "TodoDescriptions": {
                    navigationAreaName: NavigationGroups.Todo,
                    icon: "fas fa-tasks",
                    label: "General_Label_TodoDescriptions",
                    colorClass: "w3-blue",
                    roles: ["MainCatalogsEditor_Todos"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Todo,
                    classname: MainCatalogs_Classes.TodoDescription,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "TodoCategories": {
                    navigationAreaName: NavigationGroups.Todo,
                    icon: "fas fa-cubes",
                    label: "General_Label_TodoCategories",
                    colorClass: "w3-khaki",
                    roles: ["MainCatalogsEditor_Todos"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Todo,
                    classname: MainCatalogs_Classes.TodoCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "TodoTodoStatus": {
                    navigationAreaName: NavigationGroups.Todo,
                    icon: "fas fa-traffic-light",
                    label: "General_Label_TodoStatus",
                    colorClass: "w3-amber",
                    roles: ["MainCatalogsEditor_Todos"],
                    //openByDefault: true,
                    featurepath: "MainCatalog/Todo",
                    classname: MainCatalogs_Classes.TodoStatus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                /**
                *
                * PROCESS ABLÄUFE
                *
                *
                */

                "EvProcessStatus": {
                    navigationAreaName: NavigationGroups.Process,
                    icon: "fas fa-file-alt",
                    label: "General_Label_EvProcessStatus",
                    colorClass: "w3-brown",
                    roles: ["MainCatalogsEditor_EvProcessStatus"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Process,
                    classname: MainCatalogs_Classes.EvProcessStatus,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                }, "EvProcessGroupCategorie": {
                    navigationAreaName: NavigationGroups.Process,
                    icon: "fas fa-clipboard-list",
                    label: "General_Label_EvProcessGroupCategorie",
                    colorClass: "w3-brown",
                    roles: ["MainCatalogsEditor_EvProcessGroupCategorie"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Process,
                    classname: MainCatalogs_Classes.EvProcessGroupCategorie,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "EvProcessGroup": {
                    navigationAreaName: NavigationGroups.Process,
                    icon: "fas fa-clipboard-list",
                    label: "General_Label_EvProcessGroup",
                    colorClass: "w3-brown",
                    roles: ["MainCatalogsEditor_EvProcessGroup"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Process,
                    classname: MainCatalogs_Classes.EvProcessGroup,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },

                /**
                 *
                 * FILE
                 *
                 *
                 */

                "FileCategory": {
                    navigationAreaName: NavigationGroups.File,
                    icon: "fas fa-archive",
                    label: "General_Label_FileCategory",
                    colorClass: "w3-deep-purple",
                    roles: ["MainCatalogsEditor_FileCategory"],
                    //openByDefault: true,
                    featurepath: "MainCatalog/File",
                    classname: MainCatalogs_Classes.FileCategory,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },


                /**
                 *
                 * SETTINGS
                 *
                 *
                 */
                "WebTranslations": {
                    navigationAreaName: NavigationGroups.Settings,
                    icon: "fas fa-language",
                    label: "General_Label_WebTranslations",
                    colorClass: "w3-teal",
                    roles: ["WebTranslationsEditor"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Settings,
                    classname: MainCatalogs_Classes.WebToolTranslations,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
                "ExtendedProperty": {
                    navigationAreaName: NavigationGroups.Settings,
                    icon: "fas fa-user-cog",
                    label: "General_Label_ExtendedProperties",
                    colorClass: "w3-teal",
                    roles: ["MainCatalogsEditor_ExtendedProperty"],
                    //openByDefault: true,
                    featurepath: FeaturePaths.Settings,
                    classname: MainCatalogs_Classes.ExtendedProperty,
                    callback: lang.hitch(this, this._onSelect_Navigation)

                },
            },
            // SORTIERUNG DER BEREICHE
            {
                [NavigationGroups.VAM]: {
                    order: 1
                },
                [NavigationGroups.Address]: {
                    order: 100
                }, [NavigationGroups.OM]: {
                    order: 200
                },[NavigationGroups.Employment]: {
                    order: 250
                },
                [NavigationGroups.Todo]: {
                    order: 350
                },[NavigationGroups.Process]: {
                    order: 400
                },
                [NavigationGroups.File]: {
                    order: 500
                },
                [NavigationGroups.Settings]: {
                    order: 999
                }
            }
         );


    }
}

export default mdsWidget(MainCatalogsNavigation);
